// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"19548ed4","453":"eb6cf302","494":"d50f826e"}[chunkId] + ".chunk.js";
};